


export interface DecodedToken {
  email?: string;
  scopes?: string[];
  iat: number;
  iss?: string;
  exp: number;
  [key: string]: any;
}

const decodeJWT = (token: string): DecodedToken => {
  if (!token) throw new Error("No token provided");

  try {
    const payload = token.split(".")[1];
    if (!payload) throw new Error("Invalid token format");

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = JSON.parse(atob(base64));
    return decoded as DecodedToken;
  } catch (err) {
    throw new Error("Failed to decode JWT: " + (err instanceof Error ? err.message : String(err)));
  }
};

export default decodeJWT;